module.exports = __webpack_public_path__ + "img/bg-bank-active.7281f675.png";